/* eslint-disable import/namespace */
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'

import Router from './pages/Router/Router'

import './index.css'
import './fonts/Inter/inter.css'
import './fonts/HomemadeApple/HomemadeApple.css'
import './fonts/Montserrat/Montserrat.css'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-day-picker/dist/style.css'
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { removeLS } from './helper/LocalStorage'
import logRedirect from './helper/RedirectLogger'
import { isSentryEnabled } from './helper/SentryMonitoring'

// Sentry Initialisierung für Login-Tracking
if (isSentryEnabled) {
	try {
		const sentryConfig = {
			dsn: process.env.REACT_APP_SENTRY_DSN,
			integrations: [
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration(),
			],
			sendDefaultPii: true,
			tracesSampleRate: 1.0,
			replaysSessionSampleRate: 1,
			replaysOnErrorSampleRate: 1.0,
			environment: process.env.NODE_ENV || 'development',
		}

		// Proxy-Konfiguration: Wenn REACT_APP_SENTRY_PROXY_URL gesetzt ist, verwende Tunnel
		if (process.env.REACT_APP_SENTRY_PROXY_URL) {
			sentryConfig.tunnel = process.env.REACT_APP_SENTRY_PROXY_URL
		}

		Sentry.init(sentryConfig)
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('[SENTRY] Initialization failed:', error)
	}
}

const root = ReactDOM.createRoot(document.getElementById('root'))

const LogoutComponent = () => {
	const navigate = useNavigate()
	useEffect(() => {
		logRedirect('LogoutComponent', {
			action: 'Logging out and redirecting to /login',
		})

		removeLS('auth')
		// SessionStorage für Login-Tracking zurücksetzen
		sessionStorage.removeItem('sentry_login_token')
		sessionStorage.removeItem('sentry_login_session_id')

		// Sentry User-Kontext zurücksetzen
		try {
			Sentry.setUser(null)
		} catch (error) {
			// Fallback falls Sentry nicht initialisiert ist
			// eslint-disable-next-line no-console
			console.warn('[LOGOUT] Sentry not available:', error)
		}

		logRedirect('LogoutComponent', {
			from: window.location.pathname,
			to: '/login',
			action: 'React Router navigate to /login',
		})

		navigate('/login')
	}, [navigate])
	return <></>
}

const App = () => {
	useEffect(() => {
		logRedirect('App', {
			action: 'App component mounted',
		})
	}, [])

	return (
		<div className="flex w-full h-screen font-medium font-inter">
			<BrowserRouter>
				<Routes>
					<Route path="/logout" element={<LogoutComponent />} />
					<Route path="*" element={<Router />} />
				</Routes>
			</BrowserRouter>
		</div>
	)
}

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
	root.render(<App />)
} else {
	root.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>
	)
}
